import { render, staticRenderFns } from "./OpCard.vue?vue&type=template&id=724b344e&"
import script from "./OpCard.vue?vue&type=script&lang=ts&"
export * from "./OpCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports